import {LocalStorageKey, fromLocalStorage, removeFromLocalStorage} from 'Shared/utilities/localStorage';
import {map as IOmap} from 'fp-ts/lib/IO';
import {fromNullable, isSome} from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

export const useRedirectToRequestedPage = () => {
  const history = useHistory();

  useEffect(() => {
    const redirectRoute = pipe(fromLocalStorage(LocalStorageKey.RedirectRoute), IOmap(fromNullable))();
    if (isSome(redirectRoute)) {
      removeFromLocalStorage(LocalStorageKey.RedirectRoute)();
      history.push(redirectRoute.value);
    }
  }, [history]);
};
